import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Tabs = ({ children, value, onValueChange, className = "" }) => {
  return (
    <div className={`w-full ${className}`}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          if (child.type === TabsList) {
            return React.cloneElement(child, { value, onValueChange });
          } else if (child.type === TabsContent) {
            return React.cloneElement(child, { active: child.props.value === value });
          }
        }
        return child;
      })}
    </div>
  );
};

export const TabsList = ({ children, value, onValueChange, className = "" }) => {
  return (
    <div
      className={`flex flex-wrap items-center gap-2 sm:gap-4 p-2 bg-gray-100 rounded-xl w-full shadow-inner ${className}`}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.type === TabsTrigger) {
          return React.cloneElement(child, {
            active: child.props.value === value,
            onClick: () => onValueChange(child.props.value),
          });
        }
        return child;
      })}
    </div>
  );
};

export const TabsTrigger = ({
  children,
  value,
  active,
  onClick,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1 text-xs sm:text-base font-medium rounded-full transition-all duration-300 ${
        active
          ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md scale-105"
          : "bg-white text-gray-600 hover:text-indigo-600 hover:bg-gray-200"
      } ${className}`}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({ children, active, className = "" }) => {
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          key="tab-content"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2 }}
          className={`w-full mt-4 rounded-xl bg-white p-4 border shadow-sm ${className}`}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
